export default __webpack_public_path__ + "static/media/shopping-cart-2.ff937b4c.png";